import { type InquiryV2 } from '@/services/getInquiriesV2';

type InquirySubjectFields = Pick<
  NonNullable<InquiryV2['title']>,
  'cancerFocus' | 'age' | 'diagnosis'
>;

export function getInquirySubject(title?: InquirySubjectFields | null): string {
  if (!title) {
    return '';
  }

  return [title.cancerFocus, title.age, title.diagnosis].filter(Boolean).join(' • ');
}
